import { useContext, useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import AuthContext from "../context/AuthProvider";
import { useMutation } from "react-query";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

// RP(Relying Party) Logout Request Component
function RPLogout() {
  let { auth, setAuth, tenantSessions, clearTenantContext } = useContext(AuthContext);

  // Get the redirect URI from the requested
  let params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  const currentTenant = tenantSessions?.filter(
    (tenant) => tenant.tenant_id === params.tenant_id
  )[0];
  if (currentTenant?.auth && params.tenant_id) {
    setAuth(currentTenant.auth);
  }
  const axiosPrivate = useAxiosPrivate();
  const { mutate: mutateSignOut, isLoading: signOutIsLoading } = useMutation(
    (refreshToken) => {
      return axiosPrivate.post(
        "/logout",
        {
          refresh_token: refreshToken,
        },
        {
          withCredentials: true,
        }
      );
    }
  );

  // USEFFECT
  useEffect(() => {
    if (params.post_logout_redirect_uri && auth?.refresh_token) {
      mutateSignOut(auth?.refresh_token, {
        onSuccess: () => {
          window.location.href = params.post_logout_redirect_uri;
          setAuth({});
          clearTenantContext(true);
        },
        onError: () => {
          window.location.href = params.post_logout_redirect_uri;
          setAuth({});
          clearTenantContext(true);
        },
      });
    }
  }, [
    auth?.refresh_token,
    mutateSignOut,
    params.post_logout_redirect_uri,
    setAuth,
  ]);

  // RENDER
  return (
    <>
      {signOutIsLoading && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: 2,
            minHeight: "40vh",
          }}
        >
          <CircularProgress
            size={40}
            sx={{
              color: "secondary.main",
              marginTop: "-12px",
              marginLeft: "-12px",
            }}
          />
        </Box>
      )}
    </>
  );
}
export default RPLogout;
